import styled from 'styled-components'

export const StyledDivider = styled.div`
    height: 2px;
    background: ${p => p.theme.playerDividerColor};
    margin: auto;
    width: 95%;
`
